export const lowerExtremityFunctionalScaleEs = {
  promInstructions: "Hoy, ¿tienes o tendrías alguna dificultad con:",
  scaleEndLabel: "Sin Dificultad",
  scaleStartLabel: "Dificultad Extrema",
  scaleLabels: [
    "Dificultad extrema o incapaz de realizar la actividad",
    "Bastante dificultad",
    "Dificultad moderada",
    "Un poco de dificultad",
    "Sin dificultad",
  ],
  questions: [
    "Cualquiera de tus actividades usuales de trabajo, tareas domésticas o escolares.",
    "Tus pasatiempos usuales, actividades recreativas o deportivas.",
    "Entrar o salir de la bañera.",
    "Caminar entre habitaciones.",
    "Ponerse los zapatos o calcetines.",
    "Agacharse.",
    "Levantar un objeto, como una bolsa de comestibles del suelo.",
    "Realizar actividades ligeras alrededor de tu hogar.",
    "Realizar actividades pesadas alrededor de tu hogar.",
    "Entrar y salir de un automóvil.",
    "Caminar 2 cuadras.",
    "Caminar una milla.",
    "Subir y bajar 10 escalones (aproximadamente 1 piso de escaleras).",
    "Permanecer de pie durante 1 hora.",
    "Permanecer sentado durante 1 hora.",
    "Correr en terreno plano.",
    "Correr en terreno irregular.",
    "Hacer giros bruscos mientras corres rápido.",
    "Saltar.",
    "Darse vuelta en la cama.",
  ],
};
